module.exports = __webpack_public_path__ + "static/media/heart-broken.a7d971e5.svg";